import React, {createContext, useContext, useEffect, useState} from 'react';

const STORAGE_KEY = 'lastViewedCustomers';

const LastViewContext = createContext();

export function LastViewProvider({ company, children }) {
  const [lastViewed, setLastViewed] = useState([]);

  // Load from localStorage on first mount
  useEffect(() => {
    if (!company?.companyId) {
      return;
    }

    const stored = localStorage.getItem(STORAGE_KEY + '-' + company?.companyId);
    if (stored) {
      try {
        setLastViewed(JSON.parse(stored));
      } catch (e) {
        console.error('Error parsing stored customers:', e);
      }
    }
  }, [company]);

  // Save to localStorage on change
  useEffect(() => {
    if (!company?.companyId) {
      return;
    }
    localStorage.setItem(STORAGE_KEY + '-' + company?.companyId, JSON.stringify(lastViewed));
  }, [lastViewed]);

  const addCustomer = (customer) => {
    setLastViewed((prev) => {
      const filtered = prev.filter((c) => c.guid !== customer.guid);
      const updated = [customer, ...filtered].slice(0, 10);
      return updated;
    });
  };

  return (
    <LastViewContext.Provider value={{ lastViewed, addCustomer }}>
      {children}
    </LastViewContext.Provider>
  );
}

export function useLastViewed() {
  const context = useContext(LastViewContext);
  if (!context) {
    throw new Error('useLastViewed must be used within a LastViewProvider');
  }
  return context;
}
